import { render, staticRenderFns } from "./ExportToOfficeOrPDF.vue?vue&type=template&id=32af7534&scoped=true&"
import script from "./ExportToOfficeOrPDF.vue?vue&type=script&lang=js&"
export * from "./ExportToOfficeOrPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32af7534",
  null
  
)

export default component.exports